import Modal from "react-bootstrap/Modal";
import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../Style/Checkbox.scss";
import "../../Style/__button.scss";
import "../../Style/InsertModal.scss";
import { errorAlert, handleSuccess } from "../../Components/Alerts";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import LoginUserDetailed from "../../Auth/LoginUserDetailed";
import TextField from "@mui/material/TextField";
import { TextareaAutosize } from "@mui/material";
// import MenuItem from '@mui/material/MenuItem';
import { Button } from "@mui/material";
// import InsertArticleGroup from '../ArticleGroups/InsertArticleGroups';
// import InsertArticleUnit from '../ArticleUnits/InsertArticleUnits'
import AddBoxIcon from "@mui/icons-material/AddBox";
// import Select from 'react-select';
import { AddElementsButton } from "../../Components/AddElementsButton";
import Autocomplete from "@mui/material/Autocomplete";

const ledgers = [
  {
    Ledgerid: 107,
    LedgerName: "107 Artikull Mall",
  },
  {
    Ledgerid: 702,
    LedgerName: "702 Artikull Sherbim",
  },
];

function InsertArticle({ onInserted, ...props }) {
  const [barcode, setBarcode] = useState("");
  const [articlename, setArticleName] = useState("");
  const [description, setDescription] = useState("");
  const [groupId, setGroupId] = useState("");
  const [unitId, setUnitId] = useState("");
  const [ledgerId, setLedgerId] = useState("");
  const [vatId, setVatId] = useState("");
  const [purchasePrice, setPurchasePrice] = useState(0);
  const [salesPrice, setSalesPrice] = useState(0);
  const [isActive, setIsActive] = useState(true);
  const [showInPos, setShowInPos] = useState(false);

  const [purchaseNoVAT, setPurchaseNoVAT] = useState(0);
  const [salesNoVAT, setSalesNoVAT] = useState(0);
  const [valueProfit, setValueProfit] = useState(0);
  const [percentProfit, setPercentProfit] = useState(0);
  const [vatPercent, setVatPercent] = useState(0);

  const [group, setGroup] = useState([]);
  // const [filteredGroup, setFilteredGroup] = useState([]);

  const [unit, setUnit] = useState([]);
  // const [filteredUnit, setfilteredUnit] = useState([]);

  const [ledger, setLedger] = useState([]);
  // const [filteredLedger, setFilteredLedger] = useState([]);

  const [vat, setVat] = useState([]);
  // const [filteredVat, setFilteredVat] = useState([]);

  const email = LoginUserDetailed(); // ndryshoni me emailin e përdoruesit të kyqur
  const headers = authHeader();

  const [isVatDeclarant, setIsVatDeclarant] = useState(false);

  const [groupError, setGroupError] = useState("");
  const [unitError, setUnitError] = useState("");
  const [ledgerError, setLedgerError] = useState("");
  const [vatError, setVatError] = useState("");

  const [barcodeExist, setBarcodeExsit] = useState("");
  const [msgBarcode, setMsgBarcode] = useState("");
  const [articleExist, setArticleExist] = useState("");
  const [msgArticle, setMsgArticle] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    if (barcodeExist > 0) {
      setMsgBarcode("Ky barkod është përdorur");
      return;
    } else {
      setMsgBarcode("");
    }
    if (articleExist > 0) {
      setMsgArticle("Ky emertim ekziston");
      return;
    } else {
      setMsgArticle("");
    }
    if (groupId == null || groupId == "") {
      setGroupError("Ju lutem zgjedhni grupin");
      return;
    } else {
      setGroupError("");
    }
    if (unitId == null || unitId == "") {
      setUnitError("Ju lutem zgjedhni njesinë");
      return;
    } else {
      setUnitError("");
    }
    if (ledgerId == null || ledgerId == "") {
      setLedgerError("Ju lutem zgjedhni llogarin kontabël");
      return;
    } else {
      setLedgerError("");
    }
    if (vatId == null || vatId == "") {
      setVatError("Ju lutem zgjedhni normën e TVSH-s");
      return;
    } else {
      setVatError("");
    }
    const stateData = {
      Barcode: barcode,
      ArticleName: articlename,
      Description: description,
      GroupID: groupId,
      UnitID: unitId,
      LedgerID: ledgerId,
      VAT: vatId,
      PurchasePrice: purchasePrice,
      SalesPrice: salesPrice,
      IsActive: isActive,
      TouchScreen: showInPos,
      CreatedByUser: email,
    };
    axios
      .post(ApiLink.API_URL + "article", stateData, { headers })
      .then((response) => {
        // console.log(response.data);
        handleSuccess("Artikulli u insertua me sukses");
        setBarcode("");
        setArticleName("");
        setDescription("");
        setGroupId("");
        setUnitId("");
        setLedgerId("");
        setVatId("");
        setPurchasePrice(0);
        setSalesPrice(0);
        setIsActive(true);
        setShowInPos(false);
        setGroupName("");
        setUnitName("");
        setLedgerName("");
        props.onHide();
        props.refreshData(); // Thirrja e funksionit per refresh te dhenave
        fetchNextBarcode();
        setPurchaseNoVAT(0);
        setSalesNoVAT(0);
        setValueProfit(0);
        setPercentProfit(0);
        onInserted?.();
      })
      .catch((error) => {
        // console.error(error);
        if (error.response && error.response.status === 409) {
          errorAlert(error.response.data);
        } else {
          //   errorAlert("An unknown error occurred while processing the request.");
        }
      });
  };

  const handleClose = () => {
    // Ky funksion do të përdoret për të mbyllur modalin
    props.onHide();
    setBarcode("");
    setArticleName("");
    setDescription("");
    setGroupId("");
    setUnitId("");
    setLedgerId("");
    setVatId("");
    setPurchasePrice(0);
    setSalesPrice(0);
    setIsActive(true);
    setShowInPos(false);
    setGroupName("");
    setUnitName("");
    setLedgerName("");
    fetchNextBarcode();
    setPurchaseNoVAT(0);
    setSalesNoVAT(0);
    setValueProfit(0);
    setPercentProfit(0);
  };

  const fetchArticleGroups = async () => {
    try {
      const response = await axios.get(ApiLink.API_URL + "ArticleGroup", {
        headers,
      });
      setGroup(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchArticleUnits = async () => {
    try {
      const response = await axios.get(ApiLink.API_URL + "articleunits", {
        headers,
      });
      setUnit(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  //Kodi per shfaqjen e Ledgers ne Select List
  useEffect(() => {
    axios
      .get(ApiLink.API_URL + "Ledger/gettwoledgers", { headers })
      .then((response) => {
        setLedger(response.data);
      })
      .catch((error) => {
        // console.error(error);
      });
  }, []);

  const fetchVatRates = async () => {
    try {
      const response = await axios.get(ApiLink.API_URL + "vatrates", {
        headers,
      });
      setVat(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchNextBarcode = async () => {
    try {
      const response = await axios.get(ApiLink.API_URL + "Article/Barcode", {
        headers,
      });
      setBarcode(response.data.NextBarcode);
    } catch (error) {
      // errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        // errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë.");
      }
    }
  };
  const handleAutocompleteVAT = (event, value) => {
    if (value) {
      // setFormData((prevState) => ({
      //     ...prevState,
      //     LedgerID: value.LedgerID,
      // }));
      setVatId(value.VATID);
      setVatPercent(value.VATPercent);
    } else {
      // setFormData((prevState) => ({
      //     ...prevState,
      //     LedgerID: "",
      // }));
      setVatId("");
      setVatPercent(0);
    }
  };

  const defaultPropsVAT = {
    options: vat,
    getOptionLabel: (option) => `${option.VATName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            <b> {option.VATName}</b>
            <br />
          </span>
        </li>
      </>
    ),
  };

  const checkBarcode = async (barcode) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Article/checkBarcode",
        { headers, params: { barcode: barcode } },
      );
      setBarcodeExsit(response.data[0].Barcode);

      if (response.data[0].Barcode > 0) {
        setMsgBarcode("barcode exist");
      } else {
        setMsgBarcode("");
      }
    } catch (error) {
      // errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        // errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };
  const fetchCompanyVATStatus = async (vatData) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Companies/getCompanyDetails",
        { headers },
      );
      const isCompanyVatDeclarant = response.data[0].VATDeclarant;

      setIsVatDeclarant(isCompanyVatDeclarant);

      // Nëse nuk është deklarues i TVSH-së, kërko VATID me VATPercent = 0
      if (!isCompanyVatDeclarant) {
        const vatZero = vatData.find((v) => v.VATPercent === 0);
        if (vatZero) {
          setVatId(vatZero.VATID);
        } else {
          errorAlert("Nuk u gjet ndonjë normë me VATPercent = 0");
        }
      }
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (error.response?.data?.errorMessage) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };
  const checkArticleName = async (articleName) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Article/chectArticleName",
        { headers, params: { articleName: articleName } },
      );
      setArticleExist(response.data[0].ArticleName);
      if (response.data[0].ArticleName > 0) {
        setMsgArticle("Article exist");
      } else {
        setMsgArticle("");
      }
    } catch (error) {
      // errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        // errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  //Ky funksion perdoret per ta kalkuluar qmimin pa tvsh, bazuar ne parametrat e derguar
  const calcPriceWith = (price, vatPercent, hasVAT) => {
    //gjeje qmimin pa tvsh bazuar ne qmimin me tvsh
    if (hasVAT === "withVAT") {
      return (Number(price) * Number(100)) / (Number(100) + Number(vatPercent));
    } else if (hasVAT === "noVAT") {
      return Number(price) * (Number(1) + Number(vatPercent) / Number(100));
    }
  };

  const calcPriceFromPriceWithVAT = async (price, vat, priceType) => {
    try {
      if (priceType === "purchaseWithVAT") {
        // const noVAT = (Number(price) * Number(100)) / (Number(100) + Number(vat));
        setPurchaseNoVAT(calcPriceWith(price, vat, "withVAT"));
      } else if (priceType === "purchaseWithoutVAT") {
        setPurchasePrice(calcPriceWith(price, vat, "noVAT"));
      } else if (priceType === "salesWithVAT") {
        // const noVAT = (Number(price) * Number(100)) / (Number(100) + Number(vat));
        const noVAT = calcPriceWith(price, vat, "withVAT");
        setSalesNoVAT(noVAT);

        const profitiNeVlerPaTVSH = Number(noVAT) - Number(purchaseNoVAT);
        setValueProfit(profitiNeVlerPaTVSH);

        const profitiVlerMeTVSH = Number(price) / Number(purchasePrice);

        setPercentProfit((Number(profitiVlerMeTVSH) - Number(1)) * Number(100));
      } else if (priceType === "salesWithoutVAT") {
        const salesWithVAT = calcPriceWith(price, vat, "noVAT");
        setSalesPrice(salesWithVAT);

        const profitiNeVlerPaTVSH = Number(price) - Number(purchaseNoVAT);
        setValueProfit(profitiNeVlerPaTVSH);

        const profitiVlerMeTVSH = Number(salesWithVAT) / Number(purchasePrice);
        setPercentProfit((Number(profitiVlerMeTVSH) - Number(1)) * Number(100));
      }
    } catch (error) {
      console.error("Error during calculation:", error);
      // Perform any necessary error handling here
    }
  };

  const KalkulimiCmimitNgaProfitiNgaVlera = (
    valueProfit,
    priceWithoutVAT,
    vatPercent,
  ) => {
    // Calculate the selling price without VAT
    const cmimiShitjesPaTVSH = Number(priceWithoutVAT) + Number(valueProfit);
    setSalesNoVAT(cmimiShitjesPaTVSH);

    // Calculate the profit percentage
    const profitiNePerqindje =
      (Number(valueProfit) / Number(priceWithoutVAT)) * Number(100);
    setPercentProfit(profitiNePerqindje);

    // Calculate VAT and the selling price with VAT
    const TVSH =
      Number(cmimiShitjesPaTVSH) * (Number(vatPercent) / Number(100));
    const cmimiShitjesMeTVSH = Number(cmimiShitjesPaTVSH) + Number(TVSH);
    setSalesPrice(cmimiShitjesMeTVSH);
  };

  function KalkulimiCmimitNgaProfitiNgaPerqindja(
    profitPercent,
    purchasePriceWithoutVAT,
    vatPercent,
  ) {
    // Kalkulo fitimin në përqindje
    const fitimiPerqindje =
      Number(purchasePriceWithoutVAT) * (Number(profitPercent) / Number(100));
    const cmimiShitjesPaTVSH =
      Number(purchasePriceWithoutVAT) + Number(fitimiPerqindje);
    setSalesNoVAT(cmimiShitjesPaTVSH);

    // Kalkulo TVSH-në dhe çmimin e shitjes me TVSH
    const TVSH =
      Number(cmimiShitjesPaTVSH) * (Number(vatPercent) / Number(100));
    const cmimiShitjesMeTVSH = Number(cmimiShitjesPaTVSH) + Number(TVSH);
    setSalesPrice(cmimiShitjesMeTVSH);

    // Kalkulo fitimin në vlerë
    const profitiNeVlere =
      Number(cmimiShitjesPaTVSH) - Number(purchasePriceWithoutVAT);
    setValueProfit(profitiNeVlere);
  }

  //Kodi per listen e grupeve
  const [groupName, setGroupName] = useState(null);
  const handleAutocompleteChangeGroupName = (event, value) => {
    if (value && value.GroupID) {
      setGroupId(value.GroupID);
      setGroupName(value);
    } else {
      // Në rast se vlera është pastruar
      setGroupId("");
      setGroupName(null);
    }
  };

  const defaultPropsGroupName = {
    options: group,
    getOptionLabel: (option) => `${option.GroupName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>{option.GroupName}</span>
        </li>
      </>
    ),
  };

  //Kodi per listen e Njesis
  const [unitName, setUnitName] = useState(null);
  const handleAutocompleteChangeUnit = (event, value) => {
    if (value && value.UnitID) {
      setUnitId(value.UnitID);
      setUnitName(value);
    } else {
      // Në rast se vlera është pastruar
      setUnitId("");
      setUnitName(null);
    }
  };

  const defaultPropsUnit = {
    options: unit,
    getOptionLabel: (option) => `${option.UnitName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>{option.UnitName}</span>
        </li>
      </>
    ),
  };

  //Kodi per listen e Ledger
  const [ledgerName, setLedgerName] = useState(null);
  const handleAutocompleteChangeLedger = (event, value) => {
    if (value && value.Ledgerid) {
      setLedgerId(value.Ledgerid);
      setLedgerName(value);
    } else {
      // Në rast se vlera është pastruar
      setLedgerId("");
      setLedgerName(null);
    }
  };

  const defaultPropsLedger = {
    options: ledgers,
    getOptionLabel: (option) => `${option.LedgerName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>{option.LedgerName}</span>
        </li>
      </>
    ),
  };

  useEffect(() => {
    fetchArticleGroups();
    fetchArticleUnits();
    fetchVatRates();
    fetchNextBarcode();
    // fetchCompanyVATStatus();
  }, []);

  // useEffect(() => {
  //     if (vat.length > 0) {
  //         fetchCompanyVATStatus();
  //     }
  // }, [vat]);

  useEffect(() => {
    if (vat.length > 0) {
      fetchCompanyVATStatus(vat);
    }
  }, [vat]);

  return (
    <Modal
      {...props}
      show={props.show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header style={{ backgroundColor: "#284945" }}>
        <Modal.Title id="contained-modal-title-vcenter">
          Krijo Artikull të ri
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit} className="InsertModal__Container__Form">
          <div className="InsertModal__Container__Form__Container2">
            <div className="InsertModal__Container__Form__Container2__firstInput">
              <div className="InsertModal__Container__Form__Container2__field">
                <TextField
                  className="InsertModal__Container__Form__Container2__field__InsertField"
                  id="Barcode"
                  label="Barkodi, Psh:AC00000001"
                  variant="outlined"
                  type="text"
                  name="Barcode"
                  autoComplete="off"
                  value={barcode}
                  onChange={(event) => {
                    setBarcode(event.target.value);
                    checkBarcode(event.target.value);
                  }}
                />
                <span style={{ color: "red" }}>
                  {msgBarcode && `${msgBarcode}`}
                </span>
              </div>
              <div className="InsertModal__Container__Form__Container2__field">
                <TextField
                  className="InsertModal__Container__Form__Container2__field__InsertField"
                  required
                  id="ArticleName"
                  label="Emri i Artikullit"
                  variant="outlined"
                  type="text"
                  name="ArticleName"
                  autoComplete="off"
                  value={articlename}
                  onChange={(event) => {
                    setArticleName(event.target.value);
                    setDescription(event.target.value);
                    checkArticleName(event.target.value);
                  }}
                />
                <span style={{ color: "red" }}>
                  {msgArticle && `${msgArticle}`}
                </span>
              </div>
            </div>
            <div className="InsertModal__Container__Form__Container2__field__description">
              <TextareaAutosize
                style={{ height: "100px" }}
                className="InsertModal__Container__Form__Container2__field__descriptionArea"
                id="Description"
                label="Përshkrimi"
                variant="outlined"
                placeholder="Përshkrimi"
                type="text"
                autoComplete="off"
                name="Description"
                value={description}
                onChange={(event) => setDescription(event.target.value)}
              />
            </div>
            <div className="InsertModal__Container__Form__Container2__selects">
              <div className="InsertModal__Container__Form__Container2__selects__textfield_button">
                <Autocomplete
                  {...defaultPropsGroupName}
                  id="include-input-in-list"
                  includeInputInList
                  value={groupName && groupName.GroupID ? groupName : null} // Vlera ose null, jo "" ose diçka tjetër
                  onChange={handleAutocompleteChangeGroupName}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !option) return false;
                    return option.GroupID === value.GroupID;
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Zgjedh Grupin"
                      error={Boolean(groupError)} // Opsionale: tregon gabim në UI
                      helperText={groupError || ""}
                    />
                  )}
                />

                <span style={{ color: "red" }}>
                  {groupError && `${groupError}`}
                </span>
              </div>
              <div className="InsertModal__Container__Form__Container2__selects__textfield_button">
                <Autocomplete
                  {...defaultPropsUnit}
                  id="include-input-in-list"
                  includeInputInList
                  value={unitName && unitName.UnitID ? unitName : null}
                  onChange={handleAutocompleteChangeUnit}
                  isOptionEqualToValue={(option, value) => {
                    if (!option || !value) return false;
                    return option.UnitID === value.UnitID;
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Zgjedh Njesin"
                      error={Boolean(unitError)}
                      helperText={unitError || ""}
                    />
                  )}
                />

                <span style={{ color: "red" }}>
                  {unitError && `${unitError}`}
                </span>
              </div>
            </div>
            <div className="InsertModal__Container__Form__Container2__selects">
              <div className="InsertModal__Container__Form__Container2__selects__2">
                <Autocomplete
                  {...defaultPropsLedger}
                  id="include-input-in-list"
                  includeInputInList
                  value={ledgerName && ledgerName.Ledgerid ? ledgerName : null}
                  onChange={handleAutocompleteChangeLedger}
                  isOptionEqualToValue={(option, value) => {
                    if (!option || !value) return false;
                    return option.Ledgerid === value.Ledgerid;
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Zgjedh llojin e artikullit"
                      error={Boolean(ledgerError)}
                      helperText={ledgerError || ""}
                    />
                  )}
                />

                <span style={{ color: "red" }}>
                  {ledgerError && `${ledgerError}`}
                </span>
              </div>

              <div className="InsertModal__Container__Form__Container2__selects__2">
                <Autocomplete
                  fullWidth
                  {...defaultPropsVAT}
                  id="VATID"
                  includeInputInList
                  onChange={handleAutocompleteVAT}
                  value={vat.find((option) => option.VATID === vatId) || null}
                  isOptionEqualToValue={(option, value) => {
                    if (!option || !value) return false;
                    return option.VATID === value.VATID;
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Norma e TVSH-së"
                      className="SalesDetail__Container__Form__TextField__2"
                    />
                  )}
                />

                <span style={{ color: "red" }}>
                  {vatError && `${vatError}`}
                </span>
              </div>
            </div>
            {isVatDeclarant ? (
              <>
                <div className="InsertModal__Container__Form__Container2__firstInput">
                  <div className="InsertModal__Container__Form__Container2__field">
                    <TextField
                      style={{ width: "100%" }}
                      id="PurchasePriceNoVAT"
                      label="Cmimi i blerjës pa TVSH"
                      variant="outlined"
                      name="PurchasePriceNoVAT"
                      // value={purchaseNoVAT}
                      value={
                        purchaseNoVAT !== null
                          ? purchaseNoVAT.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                            })
                          : "0.00"
                      }
                      onChange={(event) => setPurchaseNoVAT(event.target.value)}
                      onKeyUp={(event) =>
                        calcPriceFromPriceWithVAT(
                          event.target.value,
                          vatPercent,
                          "purchaseWithoutVAT",
                        )
                      }
                    />
                  </div>

                  <div className="InsertModal__Container__Form__Container2__field">
                    <TextField
                      style={{ width: "100%" }}
                      id="PurchasePrice"
                      label="Cmimi i Blerjes me TVSH"
                      variant="outlined"
                      name="PurchasePrice"
                      // value={purchasePrice}
                      value={
                        purchasePrice !== null && purchasePrice !== 0
                          ? purchasePrice.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                            })
                          : "0.00"
                      }
                      onChange={(event) => setPurchasePrice(event.target.value)}
                      onKeyUp={(event) =>
                        calcPriceFromPriceWithVAT(
                          event.target.value,
                          vatPercent,
                          "purchaseWithVAT",
                        )
                      }
                    />
                  </div>
                </div>
                <div className="InsertModal__Container__Form__Container2__firstInput">
                  <div className="InsertModal__Container__Form__Container2__field">
                    <TextField
                      style={{ width: "100%" }}
                      id="SalesPrice"
                      label="Cmimi i shitjës Pa TVSH"
                      variant="outlined"
                      name="SalesPrice"
                      // value={salesNoVAT}
                      value={
                        salesNoVAT !== null && salesNoVAT !== 0
                          ? salesNoVAT.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                            })
                          : "0.00"
                      }
                      onChange={(event) => setSalesNoVAT(event.target.value)}
                      onKeyUp={(event) =>
                        calcPriceFromPriceWithVAT(
                          event.target.value,
                          vatPercent,
                          "salesWithoutVAT",
                        )
                      }
                    />
                  </div>
                  <div className="InsertModal__Container__Form__Container2__field">
                    <TextField
                      style={{ width: "100%" }}
                      id="SalesPrice"
                      label="Cmimi i Shitjes me TVSH"
                      variant="outlined"
                      name="SalesPrice"
                      // value={salesPrice}
                      value={
                        salesPrice !== null && salesPrice !== 0
                          ? salesPrice.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                            })
                          : "0.00"
                      }
                      onChange={(event) => setSalesPrice(event.target.value)}
                      onKeyUp={(event) =>
                        calcPriceFromPriceWithVAT(
                          event.target.value,
                          vatPercent,
                          "salesWithVAT",
                        )
                      }
                    />
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="InsertModal__Container__Form__Container2__firstInput">
                  <div className="InsertModal__Container__Form__Container2__field">
                    <TextField
                      style={{ width: "100%" }}
                      id="PurchasePriceNoVAT"
                      label="Cmimi i blerjës pa TVSH"
                      variant="outlined"
                      name="PurchasePriceNoVAT"
                      // value={purchaseNoVAT}
                      value={
                        purchaseNoVAT !== null
                          ? purchaseNoVAT.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                            })
                          : "0.00"
                      }
                      onChange={(event) => setPurchaseNoVAT(event.target.value)}
                      onKeyUp={(event) =>
                        calcPriceFromPriceWithVAT(
                          event.target.value,
                          vatPercent,
                          "purchaseWithoutVAT",
                        )
                      }
                    />
                  </div>
                  <div className="InsertModal__Container__Form__Container2__field">
                    <TextField
                      style={{ width: "100%" }}
                      id="SalesPrice"
                      label="Cmimi i shitjës Pa TVSH"
                      variant="outlined"
                      name="SalesPrice"
                      // value={salesNoVAT}
                      value={
                        salesNoVAT !== null && salesNoVAT !== 0
                          ? salesNoVAT.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                            })
                          : "0.00"
                      }
                      onChange={(event) => setSalesNoVAT(event.target.value)}
                      onKeyUp={(event) =>
                        calcPriceFromPriceWithVAT(
                          event.target.value,
                          vatPercent,
                          "salesWithoutVAT",
                        )
                      }
                    />
                  </div>
                </div>
              </>
            )}

            <div className="InsertModal__Container__Form__Container2__firstInput">
              <div className="InsertModal__Container__Form__Container2__field">
                <TextField
                  style={{ width: "100%" }}
                  id="ValueProfit"
                  label="Profiti në vlerë"
                  variant="outlined"
                  name="ValueProfit"
                  // value={valueProfit}
                  value={
                    valueProfit !== null && valueProfit !== 0
                      ? valueProfit.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                        })
                      : "0.00"
                  }
                  onChange={(event) => setValueProfit(event.target.value)}
                  onKeyUp={(event) =>
                    KalkulimiCmimitNgaProfitiNgaVlera(
                      event.target.value,
                      purchaseNoVAT,
                      vatPercent,
                    )
                  }
                />
              </div>

              <div className="InsertModal__Container__Form__Container2__field">
                <TextField
                  style={{ width: "100%" }}
                  id="PercentProfit"
                  label="Profiti në perqindje"
                  variant="outlined"
                  name="PercentProfit"
                  // value={percentProfit}
                  value={
                    percentProfit !== null && percentProfit !== 0
                      ? percentProfit.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                        })
                      : "0.00"
                  }
                  onChange={(event) => setPercentProfit(event.target.value)}
                  onKeyUp={(event) =>
                    KalkulimiCmimitNgaProfitiNgaPerqindja(
                      event.target.value,
                      purchaseNoVAT,
                      vatPercent,
                    )
                  }
                />
              </div>
            </div>
            <div className="InsertModal__Container__Form__Container2__buttons">
              <div>
                <label className="InsertModal__Container__Form__Container2__checkbox-label">
                  <input
                    type="checkbox"
                    checked={isActive}
                    onChange={(event) => setIsActive(event.target.checked)}
                    className="InsertModal__Container__Form__Container2__checkbox-input"
                  />
                  <span className="InsertModal__Container__Form__Container2__checkbox-custom"></span>
                  Active
                </label>
              </div>
              <div>
                <label className="InsertModal__Container__Form__Container2__checkbox-label">
                  <input
                    type="checkbox"
                    checked={showInPos}
                    onChange={(event) => setShowInPos(event.target.checked)}
                    className="InsertModal__Container__Form__Container2__checkbox-input"
                  />
                  <span className="InsertModal__Container__Form__Container2__checkbox-custom"></span>
                  Shfaq ne POS
                </label>
              </div>
              <div className="InsertModal__Container__Form__Container2__save-button">
                <button
                  type="submit"
                  className="btn btn-success float-end"
                  style={{ width: "120px" }}
                >
                  Ruaj & Mbyll
                </button>
              </div>
              <Button variant="secondary" onClick={handleClose}>
                Mbyll
              </Button>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}

export default function InsertData(props, onInserted) {
  const [modalShow, setModalShow] = React.useState(false);

  const handleRefreshData = () => {
    // props.fetchData(); // Thirrja e funksionit per refresh te dhenave
    if (props.fetchData) {
      props.fetchData();
    }
  };
  return (
    <div>
      {props.type === "text" ? (
        // <button className="button-68" onClick={() => setModalShow(true)}>
        //     <i class="bi bi-plus-circle">  </i>  <span style={{ marginLeft: "5px" }} />Krijo Artikull
        // </button>
        <AddElementsButton
          text="Krijo Artikull"
          onClick={() => setModalShow(true)}
          icon="bi bi-upc-scan"
          className="button-68"
        />
      ) : props.type === "insert" ? (
        // <button className="button-15" variant="contained" onClick={() => setModalShow(true)}><i class="bi bi-upc-scan"></i>  Krijo Artikull</button>
        <AddElementsButton
          text="Krijo Artikull"
          onClick={() => setModalShow(true)}
          icon="bi bi-upc-scan"
          className="button-15"
        />
      ) : props.type === "menu" ? (
        <i class="bi bi-upc-scan" onClick={() => setModalShow(true)}></i>
      ) : (
        <AddBoxIcon
          style={{ height: "29px", color: "black" }}
          onClick={() => setModalShow(true)}
        />
      )}
      <InsertArticle
        show={modalShow}
        onHide={() => {
          setModalShow(false);
        }}
        refreshData={handleRefreshData}
        onInserted={props.onInserted}
      />
      {/* <InsertArticle
                show={modalShow}
                onHide={() => setModalShow(false)}
                refreshData={handleRefreshData}
            /> */}
    </div>
  );
}
